import { MapPin, Phone, CalendarCheck } from "lucide-react";
import { PHONE, PHONE_DISPLAY, scrollToBooking } from "@/lib/clinic";
import { Stars, GoogleG } from "./Stars";

export const TrustHeader = () => (
  <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-mint-border/60" data-testid="trust-header">
    <div className="bg-teal text-white text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 flex items-center justify-center sm:justify-between gap-3 flex-wrap">
        <span className="inline-flex items-center gap-1.5" data-testid="header-rating">
          <Stars size={12} /> <strong>5.0/5</strong> · 300+ Google Reviews
        </span>
        <span className="inline-flex items-center gap-1.5 text-white/85" data-testid="header-landmark">
          <MapPin className="h-3.5 w-3.5" /> Above Ratnadeep Supermarket, Sainikpuri
        </span>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
      <a href="/" className="flex items-center gap-2.5" data-testid="header-logo">
        <img src="/images/logo.png" alt="Smileton Dental logo" className="h-10 w-10 sm:h-11 sm:w-11 rounded-full shrink-0" />
        <span className="leading-tight">
          <span className="block font-display text-base sm:text-xl text-teal font-semibold whitespace-nowrap">Smileton Dental</span>
          <span className="hidden sm:flex items-center gap-1 text-[11px] text-ink-muted"><GoogleG className="h-3 w-3" /> Rated 5.0 in Sainikpuri</span>
        </span>
      </a>
      <div className="flex items-center gap-2 shrink-0">
        <a href={`tel:${PHONE}`} data-testid="header-call-button"
          className="inline-flex items-center gap-2 h-10 px-3 sm:px-4 rounded-full border border-teal/20 text-teal text-sm font-medium hover:bg-mint transition-colors">
          <Phone className="h-4 w-4" />
          <span className="hidden md:inline">Call Clinic ({PHONE_DISPLAY})</span>
          <span className="md:hidden sr-only">Call</span>
        </a>
        <button type="button" onClick={scrollToBooking} data-testid="header-book-button"
          className="inline-flex items-center gap-2 h-10 px-4 sm:px-5 rounded-full bg-teal text-white text-sm font-semibold hover:bg-teal-dark transition-colors">
          <CalendarCheck className="h-4 w-4" /> <span className="hidden sm:inline">Book Slot Now</span><span className="sm:hidden whitespace-nowrap">Book Now</span>
        </button>
      </div>
    </div>
  </header>
);
